import * as React from "react";

function Download(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.434 9.834L12.8 12.47V4h-1.6v8.469L8.566 9.834l-1.132 1.132L12 15.53l4.566-4.565-1.132-1.132zM20 18.4v-3.2h-1.6v3.2H5.6v-3.2H4v3.2A1.6 1.6 0 005.6 20h12.8a1.6 1.6 0 001.6-1.6z"
      />
    </svg>
  );
}

export default Download;
